import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, Outlet } from 'react-router-dom'
import {
  Layout,
  Grid,
  Space,
  Button,
  Typography,
  Link,
  Modal,
  Form,
  Input,
  Select,
  Message,
  Result,
  Avatar,
  Upload,
  Progress,
  Notification,
  Tag,
  Popconfirm
} from '@arco-design/web-react'
import {
  IconPlus,
  IconEdit,
  IconExclamationCircleFill,
  IconRefresh,
  IconCamera,
  IconEye,
  IconEyeInvisible
} from '@arco-design/web-react/icon'
import {
  birthEight,
  getuserInfo,
  putuserInfo,
  putusermobile,
  getMobileCode,
  validateUserPassword,
  validateUserCode,
  editUserPassword,
  checkWechatBind,
  deleteWechatBind,
  outAuth,
  getgrouppowerinfo,
  deleteuser,
  getconfig
} from 'api/apis'
import upload from 'api/uploads'
import { b2ValueUnit } from 'common/utils/index'
import history from 'common/utils/history'
import IdentitySelection from 'components/IdentitySelection'
import JQ from 'jquery'
import './personalcenter.scss'
import wxlogo from 'asserts/wxlogo.png'
import errorImg from 'asserts/Figure_crack.svg'
const Header = Layout.Header
const Row = Grid.Row
const Col = Grid.Col
const datas = [
  {
    label: '账号名称',
    value: '',
    key: 'nickname'
  },
  {
    label: '联系手机',
    value: '',
    key: 'mobile',
    edit: false
  },
  {
    label: '联系邮箱',
    value: '',
    key: 'email'
  },
  {
    label: '用户ID',
    value: '',
    key: 'id'
  },
  {
    label: '微信',
    value: false,
    key: 'bind_wechat'
  },
  {
    label: '公司名称',
    value: '',
    key: 'enterprise_name'
  }
]
const identityList = {
  PERSONAL: '个人用户',
  SUPER_ADMIN: '超级管理员',
  ADMIN: '管理员',
  STAFF: '成员'
}
const passwordFieldKeys = [
  'has_password',
  'hasPassword',
  'password_set',
  'passwordStatus',
  'password_status',
  'is_set_password',
  'isSetPassword',
  'login_password_set',
  'loginPasswordSet'
]
const getPasswordConfigured = (userinfo = {}) => {
  for (let i = 0; i < passwordFieldKeys.length; i += 1) {
    const value = userinfo[passwordFieldKeys[i]]
    if (typeof value !== 'undefined' && value !== null) {
      return Boolean(value)
    }
  }
  return Boolean(userinfo.login_md5_key)
}
const getPasswordTypeCount = (password = '') => {
  const typeList = [
    /[A-Z]/.test(password),
    /[a-z]/.test(password),
    /[0-9]/.test(password),
    /[^A-Za-z0-9]/.test(password)
  ]
  return typeList.filter(Boolean).length
}
const validatePasswordStrength = (password = '') => {
  if (!password) {
    return '请输入新密码'
  }
  if (password.length < 8 || password.length > 20) {
    return '密码长度需为 8-20 位字符'
  }
  if (getPasswordTypeCount(password) < 2) {
    return '密码需至少包含大小写字母、数字、特殊符号中的 2 种'
  }
  return ''
}
const maskMobile = (mobile) => {
  if (!mobile) {
    return '--'
  }
  const mobileStr = String(mobile)
  if (mobileStr.length < 7) {
    return mobileStr
  }
  return `${mobileStr.slice(0, 3)}****${mobileStr.slice(-4)}`
}
const getResetToken = (data) => {
  if (!data) {
    return ''
  }
  if (typeof data === 'string') {
    return data
  }
  const tokenKeys = [
    'resetToken',
    'reset_token',
    'token',
    'resetPasswordToken',
    'reset_password_token'
  ]
  for (let i = 0; i < tokenKeys.length; i += 1) {
    if (data[tokenKeys[i]]) {
      return data[tokenKeys[i]]
    }
  }
  return ''
}

export default function PersonalCenterinfo() {
  const [align, setAlign] = useState('center')
  const [data, setStr] = useState(datas)
  const navigate = useNavigate()
  const [other, setOther] = useState(0) //触发 render刷新 非必须可用项目其他方式
  const [isEdit, setisEdit] = useState(false)
  const [visibloperatio, setvisibloperatio] = useState(false)
  const [visible, setVisible] = React.useState(false)
  const [unbound, setUnbound] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [userinfo, setUserinfo] = useState({})
  const [showqrcode, setShowqrcode] = useState()
  const [refresh, setRefresh] = useState(false)
  const [secondsdata, setSecondsdata] = useState(false)
  const [avatar, setAvatar] = useState()
  const [file, setFile] = React.useState()
  const [identity, setidentity] = useState('')
  const [pathname, setpathname] = useState('')
  const [visibloperatio2, setVisibleoperation2] = useState(false)
  const [powerinfo, setpowerinfo] = useState()
  const [explain, setexplain] = useState()
  const [passwordVisible, setPasswordVisible] = useState(false)
  const [passwordMode, setPasswordMode] = useState('set')
  const [passwordForgotFlow, setPasswordForgotFlow] = useState(false)
  const [passwordStep, setPasswordStep] = useState(1)
  const [passwordLoading, setPasswordLoading] = useState(false)
  const [passwordCodeLoading, setPasswordCodeLoading] = useState(false)
  const [passwordCodeSeconds, setPasswordCodeSeconds] = useState(0)
  const [passwordDone, setPasswordDone] = useState(false)
  const [passwordResetToken, setPasswordResetToken] = useState('')
  const [passwordForm, setPasswordForm] = useState({
    oldPassword: '',
    code: '',
    newPassword: '',
    confirmPassword: ''
  })
  const [passwordInputType, setPasswordInputType] = useState({
    oldPassword: 'password',
    newPassword: 'password',
    confirmPassword: 'password'
  })
  const cs = `arco-upload-list-item${
    file && file.status === 'error' ? ' is-error' : ''
  }`
  const timeout = useRef(null)
  const passwordTimeout = useRef(null)
  const passwordCodeTimeout = useRef(null)
  const passwordConfigured = getPasswordConfigured(userinfo)
  const isPasswordDirectPhoneFlow =
    passwordMode === 'set' || (passwordMode === 'change' && passwordForgotFlow)
  const passwordSteps =
    isPasswordDirectPhoneFlow
      ? ['验证手机号', '设置新密码', '完成']
      : ['验证原密码', '验证手机号', '设置新密码', '完成']
  const setStrs = (label, value) => {
    data.map((ii, idx) => {
      if (ii.label == label) {
        data[idx].value = value
      }
    })
    setOther(Math.random())
  }
  const setvisibleUpgrade = () => {
    history.push('/privilege')
    history.go()
  }
  const handlePreservation = () => {
    var regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
    if (data[2].value && !regEmail.test(data[2].value)) {
      Notification.warning({ content: '邮箱格式信息错误！' })
      return false
    } else if (data[0].value.length < 2) {
      Notification.warning({ content: '账号名称不能小于两个字符！' })
      return false
    }
    let params = {
      nickname: data[0].value,
      email: data[2].value,
      company: data[5].value,
      avatar: avatar
    }
    //console.log(params, '修改数据');
    putuserInfo(params).then((res) => {
      if (res.code === 200) {
        Message.success('保存成功!')
        JQ('#infoselect').find('.username-ellipsis').text(params.nickname)
      }
    })
    // let mobileparams = {
    //     mobile: data[1].value,
    //     token: '',
    //     code: ''
    // }
    // putusermobile(mobileparams).then(res => {
    // })
    setisEdit(false)
  }
  const handleUnbound = () => {
    setVisible(true)
    setUnbound(true)
  }
  const getRecord = (news) => {
    setRefresh(false)
    birthEight().then((res) => {
      //console.log(res);
      if (res.code == 200) {
        let showqrcode =
          'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' +
          res.data.ticket
        //console.log(showqrcode, 'showqrcode')
        let expire_seconds = res.data.expire_seconds
        let reskey = res.data.key
        setShowqrcode(showqrcode)
        setSecondsdata(res.data)
        setOther(Math.random())
        if (news) {
          expire_timer()
        }
      }
    })
  }
  const checkBind = (keys) => {
    checkWechatBind({ key: keys }).then((res) => {
      if (res.code === 200) {
        // let data = res.data.auth
        // localStorage.setItem('md5_key', data.signKey)
        // localStorage.setItem('token', data.token)
        usrinfo()
        clearTimeout(timeout.current)
        setVisible(false)
      } else if (res.code === 2102) {
        if (secondsdata.expire_seconds === 0) {
          clearTimeout(timeout.current)
          setRefresh(true)
          return
        }
        expire_timer()
      } else {
        Notification.error({ content: res.msg })
      }
    })
  }
  const expire_timer = (start) => {
    if (start) {
      setVisible(true)
    }
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      secondsdata.expire_seconds -= 1
      //console.log(secondsdata.expire_seconds, 'seconds')
      checkBind(secondsdata.key)
    }, secondsdata.expire_seconds * 6)
  }
  const closeafter = () => {
    setVisible(false)
    clearTimeout(timeout.current)
  }
  const onUnbound = () => {
    setLoading(true)
    deleteWechatBind().then((res) => {
      if (res.code === 200) {
        setisEdit(false)
        usrinfo()
        setOther(Math.random())
      }
      setLoading(false)
      setVisible(false)
    })
  }
  const usrinfo = () => {
    getuserInfo().then((res) => {
      if (res.code === 200) {
        let userinfodata = res.data
        setUserinfo(userinfodata)
        setAvatar(userinfodata.avatar)
        setidentity(userinfodata.group_permission)
        data.map((ii, idx) => {
          for (let i in userinfodata) {
            if (ii.key == i) {
              data[idx].value = userinfodata[ii.key]
            }
          }
        })
        setOther(Math.random())
        localStorage.setItem('userinfo', JSON.stringify(userinfodata))
      }
    })
  }
  const grouppowerinfo = () => {
    getgrouppowerinfo().then((res) => {
      if (res.code === 200) {
        let info = res.data
        setpowerinfo(info)
        //console.log(info, 'powerinfo')
      }
    })
  }
  const handleUpload = (option) => {
    upload(option)
  }
  const setFiles = (fileList, file) => {
    setFile({
      ...file,
      url: URL.createObjectURL(file.originFile)
    })
    if (file.status === 'done') {
      if (file.response) {
        setAvatar(file.response.url)
        let params = {
          avatar: file.response.url
        }
        //console.log(params, '修改数据');
        putuserInfo(params).then((res) => {
          if (res.code === 200) {
            document.getElementById('headeravatar').src = file.response.url
            Message.success('修改成功!')
          }
        })
      }
      //console.log(fileList, file, 'setFile')
    } else if (file.status === 'error') {
      Notification.error({ content: '导入失败!' })
    }
  }
  const goManagement = () => {
    history.push('/personalcenter/membermanagement')
    history.go()
  }
  const goJump = (value) => {
    history.push(value)
    window.location.reload()
  }
  const setoutAuth = () => {
    if (identityList[identity] === '超级管理员') {
      setvisibloperatio(true)
    } else {
      setVisibleoperation2(true)
    }
  }
  const delTeamMember = () => {
    let params = { ids: JSON.stringify([userinfo.id]) }
    deleteuser(params).then((res) => {
      if (res.code === 200) {
        outAuth().then((res) => {
          if (res.code === 200) {
            localStorage.clear()
            window.location.reload()
            setVisibleoperation2(false)
          } else {
            Notification.error({ content: res.msg })
          }
        })
      } else {
        Notification.error({ content: res.msg })
      }
    })
  }
  const goQuitTeam = () => {
    delTeamMember()
  }
  const colsEdit = () => {
    setisEdit(false)
    usrinfo()
  }
  const setbackground = (color) => {
    return color ? color : 'transparent'
  }
  const resetPasswordDialog = () => {
    clearTimeout(passwordTimeout.current)
    setPasswordVisible(false)
    setPasswordMode(passwordConfigured ? 'change' : 'set')
    setPasswordForgotFlow(false)
    setPasswordStep(1)
    setPasswordLoading(false)
    setPasswordCodeLoading(false)
    setPasswordCodeSeconds(0)
    setPasswordDone(false)
    setPasswordResetToken('')
    setPasswordForm({
      oldPassword: '',
      code: '',
      newPassword: '',
      confirmPassword: ''
    })
    setPasswordInputType({
      oldPassword: 'password',
      newPassword: 'password',
      confirmPassword: 'password'
    })
  }
  const openPasswordDialog = (mode) => {
    clearTimeout(passwordTimeout.current)
    setPasswordMode(mode)
    setPasswordForgotFlow(false)
    setPasswordStep(1)
    setPasswordVisible(true)
    setPasswordLoading(false)
    setPasswordCodeLoading(false)
    setPasswordCodeSeconds(0)
    setPasswordDone(false)
    setPasswordResetToken('')
    setPasswordForm({
      oldPassword: '',
      code: '',
      newPassword: '',
      confirmPassword: ''
    })
    setPasswordInputType({
      oldPassword: 'password',
      newPassword: 'password',
      confirmPassword: 'password'
    })
  }
  const onPasswordFormChange = (key, value) => {
    setPasswordForm((prev) => ({
      ...prev,
      [key]: value
    }))
  }
  const togglePasswordInputType = (key) => {
    setPasswordInputType((prev) => ({
      ...prev,
      [key]: prev[key] === 'password' ? 'text' : 'password'
    }))
  }
  const onSendPasswordCode = () => {
    const mobile = userinfo?.mobile
    if (!mobile) {
      Notification.warning({ content: '当前账号未绑定手机号，无法获取验证码' })
      return
    }
    if (passwordCodeSeconds > 0 || passwordCodeLoading) {
      return
    }
    const sendParams = {
      loginName: mobile,
      type: passwordMode === 'change' ? 'editPassword' : 'setPassword',
      area_code: '86'
    }
    setPasswordCodeLoading(true)
    getMobileCode(sendParams)
      .then((res) => {
        if (res.code === 200) {
          Message.success('验证码已发送，请注意查收')
          setPasswordCodeSeconds(60)
          clearInterval(passwordCodeTimeout.current)
          passwordCodeTimeout.current = setInterval(() => {
            setPasswordCodeSeconds((prev) => {
              if (prev <= 1) {
                clearInterval(passwordCodeTimeout.current)
                return 0
              }
              return prev - 1
            })
          }, 1000)
        } else {
          Notification.error({ content: res.msg })
        }
      })
      .finally(() => {
        setPasswordCodeLoading(false)
      })
  }
  const onVerifyOldPassword = () => {
    if (!passwordForm.oldPassword) {
      Notification.warning({ content: '请输入原密码' })
      return
    }
    setPasswordLoading(true)
    validateUserPassword({
      old_password: passwordForm.oldPassword
    })
      .then((res) => {
        if (res.code === 200) {
          setPasswordStep(2)
          Message.success('原密码验证成功')
        } else {
          Notification.error({ content: res.msg })
        }
      })
      .finally(() => {
        setPasswordLoading(false)
      })
  }
  const onVerifyPhoneCode = () => {
    if (!passwordForm.code) {
      Notification.warning({ content: '请输入验证码' })
      return
    }
    setPasswordLoading(true)
    validateUserCode({
      code: passwordForm.code
    })
      .then((res) => {
        if (res.code === 200) {
          const resetToken = getResetToken(res.data)
          setPasswordResetToken(resetToken)
          setPasswordStep(isPasswordDirectPhoneFlow ? 2 : 3)
          Message.success('手机号验证成功')
        } else {
          Notification.error({ content: res.msg })
        }
      })
      .finally(() => {
        setPasswordLoading(false)
      })
  }
  const onSubmitPassword = () => {
    const validMessage = validatePasswordStrength(passwordForm.newPassword)
    if (validMessage) {
      Notification.warning({ content: validMessage })
      return
    }
    if (!passwordForm.confirmPassword) {
      Notification.warning({ content: '请再次输入新密码' })
      return
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      Notification.warning({ content: '两次输入的密码不一致' })
      return
    }
    if (!passwordResetToken) {
      Notification.error({
        content: '手机号验证凭证缺失，请重新完成手机号验证'
      })
      return
    }
    setPasswordLoading(true)
    editUserPassword({
      resetToken: passwordResetToken,
      newPassword: passwordForm.newPassword
    })
      .then((res) => {
        if (res.code === 200) {
          usrinfo()
          setPasswordDone(true)
          setPasswordStep(isPasswordDirectPhoneFlow ? 3 : 4)
          Message.success(passwordMode === 'set' ? '密码设置成功' : '密码修改成功')
        } else {
          Notification.error({ content: res.msg })
        }
      })
      .finally(() => {
        setPasswordLoading(false)
      })
  }
  const onPasswordNext = () => {
    if (isPasswordDirectPhoneFlow) {
      if (passwordStep === 1) {
        onVerifyPhoneCode()
      } else if (passwordStep === 2) {
        onSubmitPassword()
      }
      return
    }
    if (passwordStep === 1) {
      onVerifyOldPassword()
    } else if (passwordStep === 2) {
      onVerifyPhoneCode()
    } else if (passwordStep === 3) {
      onSubmitPassword()
    }
  }
  const onPasswordPrev = () => {
    if (passwordStep === 1) {
      resetPasswordDialog()
      return
    }
    if (isPasswordDirectPhoneFlow && passwordStep === 2) {
      setPasswordResetToken('')
    }
    setPasswordStep(passwordStep - 1)
  }
  const onForgetOldPassword = () => {
    setPasswordForgotFlow(true)
    setPasswordStep(1)
    setPasswordResetToken('')
    setPasswordForm((prev) => ({
      ...prev,
      oldPassword: '',
      code: '',
      newPassword: '',
      confirmPassword: ''
    }))
  }
  const renderPasswordField = (key, placeholder) => {
    return (
      <div className="password-text-input-shell">
        <Input
          className="password-text-input-control"
          value={passwordForm[key]}
          type={passwordInputType[key]}
          placeholder={placeholder}
          onChange={(value) => onPasswordFormChange(key, value)}
        />
        <span
          className="password-text-input-trigger"
          onClick={() => togglePasswordInputType(key)}
        >
          {passwordInputType[key] === 'password' ? (
            <IconEyeInvisible />
          ) : (
            <IconEye />
          )}
        </span>
      </div>
    )
  }
  const setconfig = () => {
    getconfig({ key: 'account-privileges' }).then((res) => {
      if (res.code === 200) {
        let list = res.data
        let obj = list.value
        setexplain(obj)
      }
    })
  }
  const setvip = (res) => {
    let list = []
    let isvip = 'PERSONAL'
    let vip_grade = userinfo && userinfo.vip_level
    if (!res[identity]) {
      isvip = 'COMPANY'
    }
    list = res[isvip]['vip' + vip_grade]
    return list
  }
  function imgError(e) {
    let evn = e
    let img = evn.srcElement ? evn.srcElement : evn.target
    img.src = errorImg
  }
  useEffect(() => {
    const urlParams = new URL(window.location.href)
    const pathname = urlParams?.pathname
    setpathname(pathname)
    if (pathname === '/personalcenter') {
      setStr(data)
      getRecord()
      usrinfo()
      grouppowerinfo()
      setconfig()
    }
    return () => {
      clearTimeout(timeout.current)
      clearTimeout(passwordTimeout.current)
      clearInterval(passwordCodeTimeout.current)
    }
  }, [])

  return (
    <div className="main-content personal">
      <>
        {pathname !== '/personalcenter' ? (
          <Outlet />
        ) : (
          <>
            <Header>
              <div className="Header-init">
                <div className="Header-title">
                  <Space align={'center'}>
                    <Typography.Text>个人中心</Typography.Text>
                  </Space>
                </div>
              </div>
            </Header>
            <div className="Card-main">
              <div className="personal-order-card">
                <div className="personal-card-title">基本信息</div>
                <div className="personal-card-header-extra">
                  {isEdit ? (
                    <Space align={align}>
                      <Button
                        className={'custom-cancel-button'}
                        style={{ padding: '0 7px' }}
                        onClick={() => colsEdit()}
                      >
                        取消
                      </Button>
                      <Button
                        className={'custom-confirm-button'}
                        style={{ padding: '0 7px' }}
                        onClick={() => handlePreservation()}
                      >
                        保存
                      </Button>
                    </Space>
                  ) : (
                    <Button type="outline" onClick={() => setisEdit(true)}>
                      修改
                    </Button>
                  )}
                </div>
                <div className="personal-card-table">
                  <Row className="grid-gutter-demo" gutter={72}>
                    <Col flex="116px">
                      <div className="arco-descriptions-row">
                        <div className="arco-descriptions-row-label">
                          账号头像：
                        </div>
                        <div className="arco-descriptions-item-value">
                          <div className="personal-avatar">
                            <Upload
                              fileList={file ? [file] : []}
                              showUploadList={false}
                              accept=".jpg,.png"
                              customRequest={(option) => {
                                handleUpload(option)
                              }}
                              onChange={(_, currentFile) => {
                                setFiles(_, currentFile)
                              }}
                              beforeUpload={(file) => {
                                var AllImgExt = '.jpg|.png|'
                                var extName = file.name
                                  .substring(file.name.lastIndexOf('.'))
                                  .toLowerCase() //（把路径中的所有字母全部转换为小写）
                                if (AllImgExt.indexOf(extName + '|') === -1) {
                                  let ErrMsg =
                                    '该文件类型不允许上传。请上传 .jpg、.png  类型的文件，当前文件类型为' +
                                    extName
                                  Message.error(ErrMsg)
                                  return false
                                }
                                const isLt10M = !(
                                  b2ValueUnit(file.size)[1] === 'B' ||
                                  b2ValueUnit(file.size)[1] === 'KB' ||
                                  (b2ValueUnit(file.size)[1] === 'MB' &&
                                    b2ValueUnit(file.size)[0] <= 5)
                                )
                                return new Promise((resolve, reject) => {
                                  if (isLt10M) {
                                    Message.error('上传文件不能大于5MB')
                                    reject()
                                  } else {
                                    resolve()
                                  }
                                })
                              }}
                            >
                              <div className={cs}>
                                {file && file.url ? (
                                  <>
                                    <Avatar
                                      triggerIcon={<span>修改</span>}
                                      triggerType="mask"
                                      size={56}
                                    >
                                      <img
                                        alt="avatar"
                                        src={avatar}
                                        onError={imgError}
                                        style={{ height: 'auto' }}
                                      />
                                    </Avatar>
                                    {file.status === 'uploading' &&
                                      file.percent < 100 && (
                                        <Progress
                                          percent={file.percent}
                                          type="circle"
                                          size="mini"
                                          style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform:
                                              'translateX(-50%) translateY(-50%)'
                                          }}
                                        />
                                      )}
                                  </>
                                ) : (
                                  <Avatar
                                    triggerIcon={<span>修改</span>}
                                    triggerType="mask"
                                    size={56}
                                  >
                                    {avatar ? (
                                      <img
                                        alt="avatar"
                                        src={avatar}
                                        onError={imgError}
                                        style={{ height: 'auto' }}
                                      />
                                    ) : (
                                      ''
                                    )}
                                  </Avatar>
                                )}
                              </div>
                            </Upload>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col flex="auto" className="flex-auto">
                      {identity && identity !== 'PERSONAL' ? (
                        <div className="arco-descriptions-row">
                          <div className="arco-descriptions-row-label">
                            身份认证：
                          </div>
                          <div className="arco-descriptions-item-value">
                            <span className="text-value">
                              {identityList[identity]}
                            </span>
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                  <Row className="grid-gutter-demo" gutter={72}>
                    <Col flex="116px">
                      <div className="arco-descriptions-row">
                        <div className="arco-descriptions-row-label">
                          {data[0].label}：
                        </div>
                        <div className="arco-descriptions-item-value">
                          {isEdit ? (
                            <Input
                              placeholder=""
                              value={data[0].value}
                              maxLength={15}
                              onChange={(value) =>
                                setStrs(data[0].label, value)
                              }
                            />
                          ) : (
                            <>
                              <span className="text-value">
                                {data[0].value}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col flex="auto" className="flex-auto">
                      <div className="arco-descriptions-row">
                        <div className="arco-descriptions-row-label">
                          {data[2].label}：
                        </div>
                        <div className="arco-descriptions-item-value">
                          {isEdit ? (
                            <Input
                              placeholder=""
                              value={data[2].value}
                              onChange={(value) =>
                                setStrs(data[2].label, value)
                              }
                            />
                          ) : (
                            <span className="text-value">{data[2].value}</span>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="grid-gutter-demo" gutter={72}>
                    <Col flex="116px">
                      <div className="arco-descriptions-row">
                        <div
                          className="arco-descriptions-row-label"
                          style={{ marginRight: 14 }}
                        >
                          {data[3].label}：
                        </div>
                        <div className="arco-descriptions-item-value">
                          <Typography.Paragraph
                            copyable
                            className={`copyable-Paragraph ${
                              isEdit ? 'text-value-edit' : ''
                            }`}
                          >
                            {data[3].value}
                          </Typography.Paragraph>
                        </div>
                      </div>
                    </Col>
                    <Col flex="auto" className="flex-auto">
                      <div className="arco-descriptions-row">
                        <div
                          className="arco-descriptions-row-label"
                          style={{ marginRight: 28 }}
                        >
                          {data[4].label}：
                        </div>
                        <div className="arco-descriptions-item-value">
                          {data[4].value ? (
                            <span
                              className="text-value"
                              style={{ paddingRight: 2 }}
                            >
                              已绑定
                            </span>
                          ) : (
                            <Link
                              style={{ textDecoration: 'underline' }}
                              onClick={() => expire_timer(true)}
                            >
                              点击绑定微信
                            </Link>
                          )}
                          {data[4].value && isEdit ? (
                            <Link
                              style={{ textDecoration: 'underline' }}
                              onClick={() => handleUnbound()}
                            >
                              点击解绑
                            </Link>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="grid-gutter-demo" gutter={72}>
                    <Col flex="116px">
                      <div className="arco-descriptions-row">
                        <div className="arco-descriptions-row-label">
                          {data[1].label}：
                        </div>
                        <div className="arco-descriptions-item-value">
                          {isEdit && data[1].edit ? (
                            <Input
                              placeholder=""
                              value={data[1].value}
                              maxLength="15"
                              onChange={(value) =>
                                setStrs(data[1].label, value)
                              }
                            />
                          ) : (
                            <span
                              className={`text-value ${
                                isEdit ? 'text-value-edit' : ''
                              }`}
                            >
                              {data[1].value}
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col flex="auto" className="flex-auto">
                        <div className="arco-descriptions-row">
                          <div className="arco-descriptions-row-label">
                            {data[5].label}：
                          </div>
                          <div className="arco-descriptions-item-value">
                            <span
                              className={`text-value ${
                                isEdit ? 'text-value-edit' : ''
                              }`}
                            >
                              {data[5].value}
                            </span>
                            {!isEdit && identity !== 'PERSONAL' ? (
                              <span
                                className="Account-operation"
                                onClick={() => goManagement()}
                              >
                                {identityList[identity] === '超级管理员' ||
                                identityList[identity] === '管理员'
                                  ? '团队管理'
                                  : '查看团队'}
                              </span>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                    </Col>
                  </Row>
                  <Row className="grid-gutter-demo" gutter={72}>
                    <Col flex="116px">
                      <div className="arco-descriptions-row">
                        <div className="arco-descriptions-row-label">
                          登录密码：
                        </div>
                        <div className="arco-descriptions-item-value login-password-status">
                          <span
                            className={`password-status ${
                              passwordConfigured ? 'is-set' : 'not-set'
                            }`}
                          >
                            {passwordConfigured ? '已设置' : '未设置'}
                          </span>
                          <Link
                            className="password-action-link"
                            onClick={() =>
                              openPasswordDialog(
                                passwordConfigured ? 'change' : 'set'
                              )
                            }
                          >
                            {passwordConfigured ? '修改密码' : '去设置'}
                          </Link>
                        </div>
                      </div>
                    </Col>
                    <Col flex="auto" className="flex-auto"></Col>
                  </Row>
                </div>
              </div>
              {/* <div className="Account-authority">
                <div className="personal-card-title rowSpaceBetween">
                  <div>
                    账户权限
                    <div
                      className={`skew-x ${
                        identity === "PERSONAL" || !identity ? "bule" : ""
                      }`}
                      onClick={() => setvisibleUpgrade(true)}
                    >
                      <div className="AlibabaPuHuiTi-Medium">
                        VIP
                        {userinfo && userinfo.vip_level > 0
                          ? userinfo.vip_level
                          : ""}
                      </div>
                    </div>
                  </div>
                  {identity === "PERSONAL" || !identity ? (
                    <span
                      className="Account-tag AlibabaPuHuiTi-Medium"
                      onClick={() => goJump("/authentication")}
                    >
                      <span></span>升级企业尊享版
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="billing-list personal-card-table">
                  <div className="billing-table">
                    <div className="table-bodys">
                      <div
                        className="table-hr"
                        style={{ "--left": "20%" }}
                      ></div>
                      {explain?.bodys.length > 0 &&
                        explain.bodys.map((item, key) => {
                          let id = "th_id" + key;
                          return (
                            <div
                              className="table-th rowStart"
                              key={key}
                              id={id}
                            >
                              <div
                                className="table-td columnCenter"
                                style={{
                                  "--width": "20%",
                                }}
                              >
                                <div
                                  className="table-td-full columnCenter"
                                  style={{
                                    "--background": setbackground("#FAFAFA"),
                                  }}
                                >
                                  {item.type}
                                </div>
                              </div>
                              <div
                                className="table-td"
                                style={{
                                  "--width": "80%",
                                }}
                              >
                                {item.body &&
                                  item.body.map((item2, key2) => {
                                    return (
                                      <div
                                        className="table-th rowCenter"
                                        key={key2}
                                      >
                                        <div
                                          className="table-hr"
                                          style={{ "--left": "30%" }}
                                        ></div>
                                        <div
                                          className="table-hr"
                                          style={{ "--left": "65%" }}
                                        ></div>
                                        <div
                                          className="table-hr"
                                          style={{ "--left": "100%" }}
                                        ></div>
                                        <div
                                          className="table-td"
                                          style={{
                                            "--width": "30%",
                                          }}
                                        >
                                          {item2.title}
                                        </div>
                                        <div
                                          className="table-td"
                                          style={{
                                            "--width": "35%",
                                          }}
                                        >
                                          <div className="table-th">
                                            {item2.model.map((item3, index) => {
                                              return (
                                                <div
                                                  className="table-th columnCenter"
                                                  key={index}
                                                >
                                                  <div>{item3}</div>
                                                </div>
                                              );
                                            })}
                                          </div>
                                        </div>
                                        <div
                                          className="table-td"
                                          style={{
                                            "--width": "35%",
                                          }}
                                        >
                                          <div className="table-th" key={key2}>
                                            {setvip(item2) &&
                                              setvip(item2).map(
                                                (item3, index) => {
                                                  return (
                                                    <div
                                                      className="table-th columnCenter"
                                                      key={index}
                                                    >
                                                      <div>{item3}</div>
                                                    </div>
                                                  );
                                                }
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div> */}
            </div>

            <Modal
              style={{
                width: 640
              }}
              title={passwordMode === 'set' ? '设置密码' : '修改密码'}
              visible={passwordVisible}
              footer={null}
              onCancel={() => resetPasswordDialog()}
              className="password-modal"
            >
              <div className="password-modal-steps">
                {passwordSteps.map((item, index) => {
                  const current = index + 1
                  const active = passwordStep >= current
                  return (
                    <div className="password-step-item" key={item}>
                      <div
                        className={`password-step-circle ${
                          active ? 'active' : ''
                        }`}
                      >
                        {current}
                      </div>
                      {index !== passwordSteps.length - 1 ? (
                        <div
                          className={`password-step-line ${
                            passwordStep > current ? 'active' : ''
                          }`}
                        ></div>
                      ) : (
                        ''
                      )}
                      <div className="password-step-title">{item}</div>
                    </div>
                  )
                })}
              </div>
              <div className="password-modal-body">
                {passwordDone ? (
                  <Result
                    status="success"
                    title={
                      passwordMode === 'set' ? '密码设置成功' : '密码修改成功'
                    }
                    subTitle={
                      passwordMode === 'set'
                        ? '登录密码已设置完成，后续可在此处修改。'
                        : '密码已更新，其他设备的登录状态将由后端统一处理。'
                    }
                    extra={
                      <Button
                        className="custom-confirm-button"
                        type="secondary"
                        onClick={() => resetPasswordDialog()}
                      >
                        完成
                      </Button>
                    }
                  />
                ) : passwordMode === 'change' &&
                  !passwordForgotFlow &&
                  passwordStep === 1 ? (
                  <div className="password-form-panel">
                    <div className="password-form-card">
                      <div className="password-form-title">验证当前登录密码</div>
                      <div className="password-form-tip">
                        为保障账号安全，修改密码前需先验证原密码。
                      </div>
                      {renderPasswordField('oldPassword', '请输入原密码')}
                    </div>
                    <div className="password-form-panel-footer">
                      <span
                        className="password-form-link"
                        onClick={() => onForgetOldPassword()}
                      >
                        忘记原密码
                      </span>
                    </div>
                  </div>
                ) : (passwordMode === 'set' && passwordStep === 1) ||
                  (passwordMode === 'change' &&
                    ((passwordForgotFlow && passwordStep === 1) ||
                      (!passwordForgotFlow && passwordStep === 2))) ? (
                  <div className="password-form-card password-form-card-code">
                    <div className="password-form-title">验证当前登录手机号</div>
                    <div className="password-mobile-tip">
                      当前绑定手机号：{maskMobile(userinfo.mobile)}
                    </div>
                    <div className="password-code-row">
                      <div className="password-code-input-shell">
                        <Input
                          className="password-code-input-inner"
                          value={passwordForm.code}
                          placeholder="请输入验证码"
                          onChange={(value) =>
                            onPasswordFormChange('code', value)
                          }
                        />
                      </div>
                      <Button
                        className="password-code-button"
                        type="outline"
                        loading={passwordCodeLoading}
                        disabled={passwordCodeLoading || passwordCodeSeconds > 0}
                        onClick={() => onSendPasswordCode()}
                      >
                        {passwordCodeSeconds > 0
                          ? `${passwordCodeSeconds}s后重试`
                          : '获取验证码'}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="password-form-card">
                    <div className="password-form-title">
                      {passwordMode === 'set'
                        ? '设置新的登录密码'
                        : '请输入新的登录密码'}
                    </div>
                    <div className="password-form-tip">
                      请设置 8-20 位密码，并满足至少 2 种字符类型组合。
                    </div>
                    {renderPasswordField('newPassword', '请输入新密码')}
                    {renderPasswordField('confirmPassword', '请再次输入新密码')}
                  </div>
                )}
              </div>
              {!passwordDone ? (
                <div className="password-modal-footer">
                  <Button
                    className="custom-cancel-button"
                    type="secondary"
                    onClick={() => onPasswordPrev()}
                  >
                    {passwordStep === 1 ? '取消' : '上一步'}
                  </Button>
                  <Button
                    className="custom-confirm-button"
                    type="secondary"
                    loading={passwordLoading}
                    onClick={() => onPasswordNext()}
                  >
                    {(isPasswordDirectPhoneFlow && passwordStep === 2) ||
                    (!isPasswordDirectPhoneFlow && passwordStep === 3)
                      ? passwordMode === 'set'
                        ? '确认设置'
                        : '确认修改'
                      : '下一步'}
                  </Button>
                </div>
              ) : (
                ''
              )}
            </Modal>
            <Modal
              title={
                <div style={{ textAlign: 'left' }}>
                  {data[4].value ? '解除绑定' : '绑定提示'}
                </div>
              }
              footer={
                data[4].value ? (
                  <>
                    <Button
                      onClick={() => {
                        setVisible(false)
                      }}
                      className="custom-cancel-button"
                    >
                      否
                    </Button>
                    <Button
                      loading={loading}
                      onClick={() => {
                        onUnbound()
                      }}
                      type="primary"
                      style={{ marginLeft: 12 }}
                      className="custom-confirm-button"
                    >
                      是
                    </Button>
                  </>
                ) : null
              }
              visible={visible}
              onCancel={() => closeafter()}
              className="Modal-ma"
            >
              {data[4].value ? (
                <p className={'unboundstyle'}>是否解除当前微信绑定？</p>
              ) : null}

              {data[4].value ? (
                ''
              ) : (
                <>
                  <div className="Modal-wxma">
                    <div className="logowx">
                      <img src={wxlogo} />
                    </div>
                    <img src={showqrcode} />
                    {refresh ? (
                      <div
                        className="order_code_mask"
                        onClick={() => getRecord(true)}
                      >
                        <IconRefresh className="freshicon" />
                        <div>二维码已过期，点击刷新</div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div>请扫码进行微信绑定</div>
                </>
              )}
            </Modal>
            <Modal
              style={{
                width: 472
              }}
              className="dissolution"
              title="解散团队"
              visible={visibloperatio}
              footer={null}
              onCancel={() => setvisibloperatio(false)}
            >
              <div style={{ textAlign: 'center' }}>
                <div className="serviceQRcode"></div>
                <div>您好，解散团队涉及较多信息确认程序</div>
                <div>请联系官方客服处理</div>
              </div>
            </Modal>
            <Modal
              style={{
                width: 472
              }}
              className="deleteModal Quit-team"
              title="退出团队"
              visible={visibloperatio2}
              okText="确认"
              cancelText="取消"
              onOk={() => goQuitTeam()}
              onCancel={() => setVisibleoperation2(false)}
            >
              <p>是否确定退出当前企业团队？</p>
            </Modal>
          </>
        )}
      </>
    </div>
  )
}
